import * as React from "react";
import { Fragment } from "react";
import { exists, t } from "i18next";

export const sortAlphabetically = (a, b) => {
  return a.toLowerCase().localeCompare(b.toLowerCase());
};

const DISPOSAL_METHODS = Object.freeze({
  "ANAEROBIC_DIGESTION": "ANAEROBIC_DIGESTION",
  "COMBUSTION": "COMBUSTION",
  "COMPOSTING": "COMPOSTING",
  "LANDFILL": "LANDFILL",
  "RECYCLED": "RECYCLED"
});

export const generatedWaste = [
  {
    activity: "CONSTRUCTION",
    types: {
      AGGREGATES: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      AVERAGE_CONSTRUCTION: [DISPOSAL_METHODS.RECYCLED],
      ASBESTOS: [DISPOSAL_METHODS.LANDFILL],
      ASPHALT: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      BRICKS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      CONCRETE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      INSULATION: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      METALS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      SOILS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      MINERAL_OIL: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION],
      PLASTERBOARD: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      TYRES: [DISPOSAL_METHODS.RECYCLED],
      WOOD: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL]
    }
  },
  {
    activity: "REFUSE",
    types: {
      HOUSEHOLD_RESIDUAL_WASTE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING,
        DISPOSAL_METHODS.LANDFILL, DISPOSAL_METHODS.ANAEROBIC_DIGESTION],
      ORGANIC_FOOD_AND_DRINK_WASTE: [DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL,
        DISPOSAL_METHODS.ANAEROBIC_DIGESTION],
      ORGANIC_GARDEN_WASTE: [DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL,
        DISPOSAL_METHODS.ANAEROBIC_DIGESTION],
      ORGANIC_MIXED_FOOD_AND_GARDEN_WASTE: [DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL,
        DISPOSAL_METHODS.ANAEROBIC_DIGESTION],
      COMMERCIAL_AND_INDUSTRIAL_WASTE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING,
        DISPOSAL_METHODS.LANDFILL, DISPOSAL_METHODS.ANAEROBIC_DIGESTION]
    }
  },
  {
    activity: "ELECTRICAL_ITEMS",
    types: {
      ELECTRICAL_ITEMS_FRIDGES_AND_FREEZERS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      ELECTRICAL_ITEMS_LARGE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      ELECTRICAL_ITEMS_IT: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      ELECTRICAL_ITEMS_SMALL: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      WEEEFRIDGES_AND_FREEZERS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      WEEELARGE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      WEEEMIXED: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      WEEESMALL: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      BATTERIES: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      BATTERIES_ALKALINE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      BATTERIES_LI_ION: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL],
      BATTERIES_NI_MH: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.LANDFILL]
    }
  },
  {
    activity: "METAL",
    types: {
      ALUMINIUM_CANS_AND_FOIL: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      MIXED_CANS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      SCRAP_METAL: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      STEEL_CANS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL]
    }
  },
  {
    activity: "PLASTIC",
    types: {
      AVERAGE_PLASTICS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      AVERAGE_PLASTIC_FILM: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      AVERAGE_PLASTIC_RIGID: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      HDPE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      LDPEAND_LLDPE: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      PET: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      PP: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      PS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      PVC: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL]
    }
  },
  {
    activity: "PAPER",
    types: {
      BOARD: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL],
      MIXED: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL],
      PAPER: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.COMPOSTING, DISPOSAL_METHODS.LANDFILL]
    }
  },
  {
    activity: "OTHER",
    types: {
      BOOKS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      GLASS: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL],
      CLOTHING: [DISPOSAL_METHODS.RECYCLED, DISPOSAL_METHODS.COMBUSTION, DISPOSAL_METHODS.LANDFILL]
    }
  }
];

export const businessTravelTransport = [
  {
    mode: "flights",
    subtypes: [
      "domestic",
      "shortHaulAveragePassenger", "shortHaulEconomyClass", "shortHaulBusinessClass",
      "longHaulAveragePassenger", "longHaulEconomyClass", "longHaulPremiumEconomyClass", "longHaulBusinessClass", "longHaulFirstClass",
      "internationalAveragePassenger", "internationalEconomyClass", "internationalPremiumEconomyClass", "internationalBusinessClass", "internationalFirstClass"
    ]
  },
  {
    mode: "ferry",
    subtypes: [
      "footPassenger", "carPassenger", "average"
    ]
  },
  {
    mode: "cars",
    subtypes: [
      "smallCarDiesel", "smallCarPetrol", "smallCarHybrid", "smallCarUnknown",
      "mediumCarDiesel", "mediumCarPetrol", "mediumCarHybrid", "mediumCarCNG", "mediumCarLPG", "mediumCarUnknown",
      "largeCarDiesel", "largeCarPetrol", "largeCarHybrid", "largeCarCNG", "largeCarLPG", "largeCarUnknown",
      "averageCarDiesel", "averageCarPetrol", "averageCarHybrid", "averageCarCNG", "averageCarLPG", "averageCarUnknown"
    ]
  },
  {
    mode: "motorbike",
    subtypes: [
      "smallMotorbike", "mediumMotorbike", "largeMotorbike", "averageMotorbike"
    ]
  },
  {
    mode: "taxis",
    subtypes: [
      "regularTaxi", "blackCab"
    ]
  },
  {
    mode: "bus",
    subtypes: [
      "localBus", "localLondonBus", "averageLocalBus", "coach"
    ]
  },
  {
    mode: "rail",
    subtypes: [
      "nationalRail", "internationalRail", "lightRailAndTram", "londonUnderground"
    ]
  }
];

export const employeeCommutingTransport = [
  {
    mode: "cars",
    subtypes: [
      "smallCarDiesel", "smallCarPetrol", "smallCarHybrid", "smallCarUnknown",
      "mediumCarDiesel", "mediumCarPetrol", "mediumCarHybrid", "mediumCarCNG", "mediumCarLPG", "mediumCarUnknown",
      "largeCarDiesel", "largeCarPetrol", "largeCarHybrid", "largeCarCNG", "largeCarLPG", "largeCarUnknown",
      "averageCarDiesel", "averageCarPetrol", "averageCarHybrid", "averageCarCNG", "averageCarLPG", "averageCarUnknown"
    ]
  },
  {
    mode: "motorbike",
    subtypes: [
      "smallMotorbike", "mediumMotorbike", "largeMotorbike", "averageMotorbike"
    ]
  },
  {
    mode: "taxis",
    subtypes: [
      "regularTaxi", "blackCab"
    ]
  },
  {
    mode: "bus",
    subtypes: [
      "localBus", "localLondonBus", "averageLocalBus", "coach"
    ]
  },
  {
    mode: "rail",
    subtypes: [
      "nationalRail", "internationalRail", "lightRailAndTram", "londonUnderground"
    ]
  },
  {
    mode: "walking",
    subtypes: []
  },
  {
    mode: "cycling",
    subtypes: []
  }
];

export const renderOptions = (optionsArr, optionsTranslationKey, alternativeLabels = []) => {
  return (
    <Fragment>
      {optionsArr.map((option, index) => {
        const label = exists(`${optionsTranslationKey}.${option}`) ?
          t(`${optionsTranslationKey}.${option}`) :
          alternativeLabels.length > 0 && alternativeLabels.length === optionsArr.length ?
            alternativeLabels[index] : option;
        return <option key={option} value={option}>
          {label}
        </option>;
      })}
    </Fragment>
  );
};

export const getProductCodeTitle = (dataArray, index, productCodes) => {
  if (dataArray[index].productCategoryId !== "" && productCodes && Object.keys(productCodes).length > 0) {
    const location = dataArray[index].location;
    const prodCatId = Number(dataArray[index].productCategoryId);
    if (location && !isNaN(prodCatId)) {
      const prodCodeObj = productCodes[location]?.find(code => code.id === prodCatId);
      return typeof prodCodeObj !== "undefined" ? `${prodCodeObj.code} - ${prodCodeObj.name}` : "";
    }
  }
  return "";
};

export const getCurrencyCode = (dataArray, index, locations) => {
  const location = dataArray[index].location;
  const foundLocObj = locations && locations.find(locationObj => locationObj.location === location);
  if (typeof foundLocObj !== "undefined") {
    return foundLocObj.currency;
  }
  return "";
};